// extracted by mini-css-extract-plugin
module.exports = {"onOffIndication":"StatusLabel-onOffIndication-2Y61EM","activityDot":"StatusLabel-activityDot-3RRlx_","active":"StatusLabel-active-2D0HCK"};